import { useState, useCallback } from 'react';
import { Stack } from '@mui/material';
import { GeneralListLayout } from 'components/layouts';
import { useI18n } from 'locales';
import PortalHeader from '../components/PortalHeader';
import SubscriptionDetailsDialog from '../subscription/components/SubscriptionDetailsDialog';

const defaultListParams = {
  sort: 'date',
  order: 'desc',
};

function PortalHistoryPage() {
  const t = useI18n();
  const [subscriptionDialogOpen, setSubscriptionDialogOpen] = useState(false);
  const [selectedSubscriptionId, setSelectedSubscriptionId] = useState(null);

  const onViewHandler = useCallback((row) => {
    if (row.subscription) {
      setSelectedSubscriptionId(row.subscription.id);
      setSubscriptionDialogOpen(true);
    }
  }, []);

  const onCloseSubscriptionDialog = useCallback(() => {
    setSubscriptionDialogOpen(false);
    setSelectedSubscriptionId(null);
  }, []);

  return (
    <>
      <PortalHeader header={t('HISTORY')} />

      <Stack gap={2} sx={{ px: 2, py: 3 }}>
        <GeneralListLayout
          model="Giving"
          title={t('GIVING RECORD')}
          defaultListParams={defaultListParams}
          onView={onViewHandler}
        />
      </Stack>

      <SubscriptionDetailsDialog
        open={subscriptionDialogOpen}
        onClose={onCloseSubscriptionDialog}
        subscriptionId={selectedSubscriptionId}
      />
    </>
  );
}

export default PortalHistoryPage;
